import { DropdownMenu } from '../form';
import { Icon } from '../UI';
import { useMarketsContext } from './MarketContext';

import { DropElemParams } from './types';

const DROPDOWN_ITEMS = ['Add to strategy', 'Add alert'];

const dropdownItems = DROPDOWN_ITEMS.map((title, i) => (
  <div className="flex items-center gap-3.5">
    <Icon svgName={i ? 'bell' : 'plus'} />
    <span>{title}</span>
  </div>
));

export const DropdownElement = ({ asset }: DropElemParams) => {
  const { addAssetToStrategy, handleAddAlert } = useMarketsContext();

  const { id, name, type } = asset;

  return (
    <DropdownMenu
      dropdownClassName="m-auto cursor-pointer"
      dropdownItems={dropdownItems}
      dropdownItemsData={DROPDOWN_ITEMS}
      handleClick={(_, e) =>
        e === 'Add to strategy'
          ? addAssetToStrategy(id, name, type ?? '')
          : handleAddAlert(asset)
      }
    >
      <Icon svgName="options" className="mr-5" />
    </DropdownMenu>
  );
};
